import { mods } from '@approvalmax/theme';
import { Button } from '@approvalmax/ui';
import { Box, Grid } from '@approvalmax/ui/src/components';
import type { StyledMods } from '@styled-kit/mods';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
    padding: 0 !important;
    height: 24px !important;
`;

export const StyledGrid = styled(Grid)<StyledMods<{ reverse: boolean }>>`
    & > * {
        transition: translate 0.2s;
    }

    ${mods('reverse', true)`
        & > *:nth-child(1),
        & > *:nth-child(2) {
            translate: 0 44px;
        }

        & > *:nth-child(3),
        & > *:nth-child(4) {
            translate: 0 -44px;
        }
    `};
`;

export const TaxCodeContainer = styled.div`
    position: relative;
`;

export const TaxCodeTooltip = styled(Box)`
    position: absolute;
    right: 0;
    top: 50%;
    translate: 100% -50%;
    line-height: 0;
`;
